export * from './delete-vermerk.service';
export * from './delete-vermerk.service.module';